import React from "react";
import * as Icons from "lucide-react";
import { Check, Star, ShieldCheck } from "lucide-react";
import { PRICING_N, INCLUDED, LINKS } from "../../data/mockNormal";
import { useReveal } from "../../hooks/useReveal";

function PlanCard({ plan, popular, cta }) {
  const ref = useReveal();
  return (
    <div ref={ref} className={`reveal glass card-lift rounded-3xl p-8 relative ${popular ? "ring-1 ring-[#f6e3a8]/50" : ""}`}>
      {popular && (
        <span className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1 text-[11px] font-semibold px-3 py-1 rounded-full btn-gold">
          <Star className="w-3 h-3 fill-[#10192c]" /> POPULAIRE
        </span>
      )}
      <p className="eyebrow text-[#7fd8e8] text-[11px]">{plan.label}</p>
      <h3 className="text-2xl md:text-3xl text-white mt-2">{plan.name}</h3>
      <div className="mt-5 text-4xl md:text-5xl font-semibold text-gold leading-none">{plan.price}€</div>
      <p className="mt-2 text-sm text-white/55">{plan.note}</p>
      <ul className="mt-6 space-y-3">
        {plan.features.map((f) => (
          <li key={f} className="flex items-start gap-3 text-white/80 text-sm">
            <Check className="w-4 h-4 text-[#7fd8e8] mt-0.5 shrink-0" />
            <span>{f}</span>
          </li>
        ))}
      </ul>
      <a href={LINKS.inscription} target="_blank" rel="noopener noreferrer" className={`mt-8 block text-center rounded-full px-6 py-3.5 font-semibold ${popular ? "btn-gold" : "btn-ghost"}`}>
        {cta}
      </a>
    </div>
  );
}

function IncludedCard({ it, i }) {
  const ref = useReveal();
  const Icon = Icons[it.icon] || Icons.Sparkles;
  return (
    <div ref={ref} className={`reveal reveal-delay-${(i % 3) + 1} glass card-lift rounded-2xl p-6`}>
      <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#1f6f8b]/40 to-[#5a5ee0]/30 flex items-center justify-center ring-1 ring-white/10 mb-4">
        <Icon className="w-5 h-5 text-[#7fd8e8]" />
      </div>
      <h4 className="text-lg text-white mb-1">{it.title}</h4>
      <p className="text-sm text-white/60">{it.text}</p>
    </div>
  );
}

export default function NormalPricing() {
  const head = useReveal();
  const incHead = useReveal();
  const guar = useReveal();
  return (
    <section id="tarifs" className="relative py-24 md:py-28">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <div ref={head} className="reveal text-center max-w-3xl mx-auto">
          <p className="eyebrow text-[#7fd8e8] text-xs mb-4">Investissement</p>
          <h2 className="text-4xl md:text-5xl text-white">L'investissement pour <span className="text-gold">rejoindre l'école</span></h2>
          <p className="mt-4 text-white/60">Ta transformation à partir de 3,75€ par jour</p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-6 items-start">
          <PlanCard plan={PRICING_N.classique} popular={false} cta="Je m'inscris" />
          <PlanCard plan={PRICING_N.vip} popular={true} cta="Je choisis VIP" />
        </div>

        <div className="mt-6 text-center">
          <span className="inline-flex items-center gap-2 text-sm text-white/60">
            <ShieldCheck className="w-4 h-4 text-[#27ae8f]" /> Essaie 14 jours · Satisfait ou Remboursé
          </span>
        </div>

        <div ref={incHead} className="reveal text-center max-w-3xl mx-auto mt-24">
          <p className="eyebrow text-[#7fd8e8] text-xs mb-4">Ce qui est inclus</p>
          <h2 className="text-4xl md:text-5xl text-white">Tout ce dont tu as besoin <span className="text-gold">pour réussir</span></h2>
        </div>
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {INCLUDED.map((it, i) => (
            <IncludedCard key={it.title} it={it} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
